import { MENU_ITEMS } from "../../data/tavern";

export default function MenuHighlights() {
  return (
    <section
      id="menu"
      data-testid="menu-section"
      className="border-t border-[color:var(--pk-border)] bg-[color:var(--pk-surface-2)]/40 py-20 md:py-28"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="mb-14 max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-[color:var(--pk-primary)]">
            ΤΟ ΜΕΝΟΥ ΜΑΣ
          </p>
          <h2 className="mt-3 font-display text-3xl font-black leading-tight tracking-tight text-[color:var(--pk-text)] sm:text-4xl md:text-5xl">
            Γεύσεις που θυμίζουν{" "}
            <span className="italic text-[color:var(--pk-primary)]">
              σπίτι
            </span>
          </h2>
          <p className="mt-4 text-base text-[color:var(--pk-text-soft)] md:text-lg">
            Φρέσκα υλικά από τον τόπο μας, ψήσιμο στα κάρβουνα και μια αγάπη που
            μεταφέρεται από γενιά σε γενιά.
          </p>
        </div>

        <div className="grid gap-7 md:grid-cols-3 md:gap-8">
          {MENU_ITEMS.map((item, idx) => (
            <article
              key={item.id}
              data-testid={`menu-item-${item.id}`}
              className="lift group flex flex-col overflow-hidden rounded-2xl border border-[color:var(--pk-border)] bg-[color:var(--pk-surface)]"
              style={{ animationDelay: `${0.1 * idx}s` }}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-[color:var(--pk-primary-dark)] px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-[#F4C96B] shadow-lg">
                  {item.badge}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-6">
                <h3 className="font-display text-xl font-bold leading-snug text-[color:var(--pk-text)] md:text-2xl">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-[color:var(--pk-text-soft)] md:text-base">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="https://www.e-food.gr/delivery/kavala/proto-katsiki"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="menu-full-btn"
            className="inline-flex items-center gap-2 rounded-full border-2 border-[color:var(--pk-primary)] px-7 py-3.5 text-sm font-bold uppercase tracking-wide text-[color:var(--pk-primary)] transition-colors hover:bg-[color:var(--pk-primary)] hover:text-white"
          >
            ΔΕΙΤΕ ΟΛΟ ΤΟ ΜΕΝΟΥ
          </a>
        </div>
      </div>
    </section>
  );
}
